var _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _circle, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaceCenteredDoubleCrosshair = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 200,
    viewBox: "0 0 172 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.93 100C169.93 154.418 132.064 198 85.9649 198C39.8655 198 2 154.418 2 100C2 45.5816 39.8655 2 85.9649 2C132.064 2 169.93 45.5816 169.93 100Z",
    stroke: "#424243",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9868 134.469V89.0183V81.6115C39.9868 79.9546 41.336 78.6459 42.9807 78.4454C47.5208 77.8921 49.1396 76.0431 50.2855 74.225C50.3837 74.0692 50.4339 73.8883 50.4339 73.7042V64.624C50.4339 63.9479 51.0831 63.4571 51.7342 63.6392C55.8758 64.7976 69.4622 68.2047 85.9887 68.2047C103.756 68.2047 108.71 65.5203 116.531 63.5545C117.155 63.3977 117.756 63.8731 117.756 64.5163V74.7538C117.756 75.0007 117.849 75.2431 118.018 75.4234C121.488 79.1338 124.432 79.3457 126.883 79.0496C128.559 78.8473 129.989 80.0027 130.06 81.6891L132.091 129.952C132.16 131.58 131.439 133.128 130.16 134.138C116.423 144.985 90.6879 167.834 85.9887 167.834C81.269 167.834 54.6872 149.002 41.7341 138.241C40.612 137.309 39.9868 135.928 39.9868 134.469Z",
    stroke: "#424243",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.578 93.7129L130.989 92.9858L132.967 124.001L143.071 119.625L141.578 93.7129Z",
    stroke: "#424243",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5806 93.7129L39.1692 92.9858V124.077L28.5806 119.625V93.7129Z",
    stroke: "#424243",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6767 92.4122C32.2469 89.8332 27.9487 33.9561 85.1154 33.9561C130.849 33.9561 137.84 73.3566 137.124 92.4122",
    stroke: "#424243",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 97,
    x2: 164.003,
    y2: 97,
    stroke: "#424243",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 137,
    x2: 164.003,
    y2: 137,
    stroke: "#424243",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 4,
    x2: 86,
    y2: 196,
    stroke: "#424243",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 98,
    r: 4,
    fill: "#424243"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 98,
    r: 4,
    fill: "#424243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70 133.5C85.5 144.5 103.5 133.5 103.5 133.5",
    stroke: "#424243",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaceCenteredDoubleCrosshair);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/face_centered_double_crosshair.277e53471da09c218fe1b614f611197d.svg";